import React, { useState, useEffect } from "react";

// Manually define which tarot cards to show
const images = [
  require("../assets/tarot/judgement.png"),
   require("../assets/tarot/fool0.png"),
  require("../assets/tarot/deathNEW.png"),
  require("../assets/tarot/moon.png"),
  require("../assets/tarot/lovers.png"),
  require("../assets/tarot/pentacles10.png"),
    require("../assets/tarot/swords6.png"),
    require("../assets/tarot/pagecups.png"),
    require("../assets/tarot/highpriestess.png"),

      require("../assets/tarot/fivePentacles.png"),
  require("../assets/tarot/justice.png"),
    require("../assets/tarot/kingPentacles.png"),
    require("../assets/tarot/swords8.png"),
  require("../assets/tarot/swords9BIG.png"),
  require("../assets/tarot/swords10.png"),
   require("../assets/tarot/cups9.png"),
      require("../assets/tarot/swordsQueen.png"),
   



  require("../assets/tarot/cups66.png"),

  require("../assets/tarot/swords10.png"),
  require("../assets/tarot/kingCups.png"),
     
];

const Tarot = () => {
  const [startIndex, setStartIndex] = useState(0);
  const [cardsPerPage, setCardsPerPage] = useState(3);

  // Determine how many cards to show based on screen width
  useEffect(() => {
    function handleResize() {
      const width = window.innerWidth;
      if (width >= 1400) {
        setCardsPerPage(6);
      } else if (width >= 1200) {
        setCardsPerPage(5);
      } else if (width >= 900) {
        setCardsPerPage(4);
      } else if (width >= 576) {
        setCardsPerPage(3);
      } else {
        setCardsPerPage(2);
      }
    }

    // Call on mount
    handleResize();

    // Add listener for window resize
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function prev() {
    setStartIndex((prev) => {
      let newIndex = prev - cardsPerPage;
      if (newIndex < 0) newIndex = Math.max(0, images.length - cardsPerPage);
      return newIndex;
    });
  }

  function next() {
    setStartIndex((prev) => {
      let newIndex = prev + cardsPerPage;
      if (newIndex >= images.length) newIndex = 0;
      return newIndex;
    });
  }

  const visibleCards = images.slice(startIndex, startIndex + cardsPerPage);

  return (
    <section id="tarot" className="pb-5" style={{ paddingBottom: "80px" }}>
      <div className="col-md-12 mx-auto">
        <div className="col-md-12">
          <h1 className="section-title" style={{ color: "black" }}>
            <span className="text-black">Tarot</span>
          </h1>
        </div>
      </div>

      <div className="col-md-10 mx-auto">
        <div className="row">
          <div className="col-md-12">
            <p><center>
              I've been working on a collage tarot deck for the last couple years, and am preparing to release it on Kickstarter Spring 2026. The project is still ongoing, updates coming soon! The full deck will feature 78 unique pieces of digital collage art from magazines and public domain photos.
            </center>
            </p>
            <break>
            </break>

            <div className="tarot-carousel-wrapper">
              <button
                className="tarot-arrow"
                onClick={prev}
                aria-label="Previous cards"
              >
                ‹
              </button>

              <div className="tarot-cards-container">
                {visibleCards.map((src, i) => (
                  <div className="tarot-card" key={startIndex + i}>
                    <img src={src} alt={`tarot-${startIndex + i}`} />
                  </div>
                ))}
              </div>

              <button
                className="tarot-arrow"
                onClick={next}
                aria-label="Next cards"
              >
                ›
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tarot;
